
export const ResearchSection = () => {
  const achievements = [
    {
      number: '25+',
      label: 'Patents',
      description: 'Core patents in marine biotechnology'
    },
    {
      number: '5 Years',
      label: 'R&D',
      description: 'Continuous biotechnology innovation'
    },
    {
      number: '100%',
      label: 'Sustainable',
      description: 'Fully eco-friendly solutions achieved'
    },
    {
      number: '75+',
      label: 'Scientists',
      description: 'Marine biotechnology experts'
    }
  ];

  const researchAreas = [
    {
      icon: 'ri-test-tube-line',
      title: 'Marine Biotechnology',
      description: 'Advanced research in marine organism extraction and biotechnological processing methods'
    },
    {
      icon: 'ri-plant-line',
      title: 'Sustainability Research',
      description: 'Development of fully sustainable bio-materials and environmental impact studies'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Bio-Material Innovation',
      description: 'Structural design research for enhanced performance and functionality of bio-materials'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety & Quality',
      description: 'Comprehensive safety verification and quality assurance for all biotechnology products'
    }
  ];

  return (
    <section id="research" className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Research & Innovation
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Leading the future of marine biotechnology through cutting-edge research and development
          </p>
        </div>

        {/* Research Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {achievements.map((achievement, index) => (
            <div key={index} className="text-center">
              <div className="bg-blue-600/20 rounded-2xl p-6 mb-4">
                <div className="text-3xl md:text-4xl font-bold text-cyan-400 mb-2">
                  {achievement.number}
                </div>
                <div className="text-lg font-semibold text-white mb-1">
                  {achievement.label}
                </div>
                <div className="text-sm text-gray-300">
                  {achievement.description}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Research Image */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/716633ed76463ca56d08dbe76892de59.jpg"
              alt="Marine Biotechnology Research"
              className="rounded-2xl shadow-2xl object-cover w-full h-96"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-2xl"></div>
          </div>

          {/* Research Areas */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold mb-8">Core Research Areas</h3>
            {researchAreas.map((area, index) => (
              <div key={index} className="bg-gray-800 rounded-xl p-6 hover:bg-gray-700 transition-colors duration-300">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${area.icon} text-cyan-400 text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-2">
                      {area.title}
                    </h4>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      {area.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-2xl p-8">
            <h3 className="text-2xl font-bold mb-4">Research Partnership</h3>
            <p className="text-lg text-blue-100 mb-6">
              Join us in pioneering the future of sustainable biotechnology solutions
            </p>
            <button className="bg-white text-blue-600 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors font-medium cursor-pointer whitespace-nowrap">
              Partnership Inquiry
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
